import * as xeronote from './types';

const getters = {
  [xeronote.DEVICE_LIST]: state => state.deviceList,
  [xeronote.DIV_LIST]: state => state.divList,
  [xeronote.PLANS]: state => state.plans,
  [xeronote.TELECOM_LIST]: state => state.telecomList,
  [xeronote.NICKNAME]: state => state.nicknameList,
};

export default getters;
